/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { ContentEditableEvent, RichTextComponent } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import { IWebformProps } from './webform.props.autogenerated';

export interface IWebFormViewProps extends IWebformProps<{}> {
    paragraph?: React.ReactNode;
    categories?: React.ReactNode;
    privacyText?: React.ReactNode;
    className?: string;
    thankYouMessageString?: string;
}

/**
 *
 * WebForm component
 */
class WebForm extends React.PureComponent<IWebformProps<{}>> {
    public render(): JSX.Element | null {
        const { paragraph, privacyText, categories, className, thankYouMessage } = this.props.config;
        const text = paragraph && (
            <RichTextComponent
                text={paragraph}
                editProps={{
                    onEdit: this.handleTextChange,
                    requestContext: this.props.context.request
                }}
            />
        );
        const textPrivacyText = privacyText && <RichTextComponent text={privacyText} />;
        const categoriesText = categories && <RichTextComponent text={categories} />;
        const WebFormViewProps = {
            ...this.props,
            paragraph: text,
            categories: categoriesText,
            privacyText: textPrivacyText,
            className: classnames('ms-webform', className),
            thankYouMessageString: thankYouMessage
        };
        return this.props.renderView(WebFormViewProps) as React.ReactElement;
    }

    public handleTextChange = (event: ContentEditableEvent) => (this.props.config.paragraph = event.target.value);
}
export default WebForm;
